import _defineProperty from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { withMemoization } from '../utils/memoization.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var shouldSendBody = function shouldSendBody(method) {
  return !['HEAD', 'GET', 'DELETE'].includes(method.toUpperCase());
}; // TODO[AllanZhengYP]: we need to provide isCanceledError utility


var fetchTransferHandler = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
    var _resp$headers, _resp$body;

    var url, method, headers, body, abortSignal, cache, withCrossDomainCredentials, resp, responseHeaders, httpResponse, bodyWithMixin;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = _ref.url, method = _ref.method, headers = _ref.headers, body = _ref.body;
            abortSignal = _ref2.abortSignal, cache = _ref2.cache, withCrossDomainCredentials = _ref2.withCrossDomainCredentials;
            _context.prev = 2;
            _context.next = 5;
            return fetch(url, {
              method: method,
              headers: headers,
              body: shouldSendBody(method) ? body : undefined,
              signal: abortSignal,
              cache: cache,
              credentials: withCrossDomainCredentials ? 'include' : 'same-origin'
            });

          case 5:
            resp = _context.sent;
            _context.next = 13;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);

            if (!(_context.t0 instanceof TypeError)) {
              _context.next = 12;
              break;
            }

            throw new Error('Network error');

          case 12:
            throw _context.t0;

          case 13:
            responseHeaders = {};
            (_resp$headers = resp.headers) === null || _resp$headers === void 0 ? void 0 : _resp$headers.forEach(function (value, key) {
              responseHeaders[key.toLowerCase()] = value;
            });
            httpResponse = {
              statusCode: resp.status,
              headers: responseHeaders,
              body: null
            }; // resp.body is a ReadableStream according to Fetch API spec, but React Native
            // does not implement it.

            bodyWithMixin = Object.assign((_resp$body = resp.body) !== null && _resp$body !== void 0 ? _resp$body : {}, {
              text: withMemoization(function () {
                return resp.text();
              }),
              blob: withMemoization(function () {
                return resp.blob();
              }),
              json: withMemoization(function () {
                return resp.json();
              })
            });
            return _context.abrupt("return", _objectSpread(_objectSpread({}, httpResponse), {}, {
              body: bodyWithMixin
            }));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 8]]);
  }));

  return function fetchTransferHandler(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();

export { fetchTransferHandler };